/* Durnev — predictive search.
   Listens to typing in the search overlay's input and fetches Shopify
   `/search/suggest.json` for live results (products + collections). The
   chips and promo card stay visible until the user starts typing; once
   the query is non-empty we hide them and show the results region. */
(function () {
  const input = document.querySelector('[data-durnev-predictive-search]');
  if (!input) return;

  const resultsBox = document.querySelector('[data-durnev-predictive-results]');
  const productsSection = document.querySelector('[data-results-products]');
  const productsList = document.querySelector('[data-results-products-list]');
  const collectionsSection = document.querySelector('[data-results-collections]');
  const collectionsList = document.querySelector('[data-results-collections-list]');
  const emptyEl = document.querySelector('[data-results-empty]');
  const queryEcho = document.querySelector('[data-results-query]');

  // Sibling sections to hide while typing — chips, promo card.
  const overlay = input.closest('.durnev-search') || document;
  const chipsWrap = overlay.querySelector('.durnev-search__chips-wrap');
  const promo = overlay.querySelector('.durnev-search__promo');

  if (!resultsBox) return;

  function setVisibleAuxiliary(visible) {
    if (chipsWrap) chipsWrap.hidden = !visible;
    if (promo) promo.hidden = !visible;
    resultsBox.hidden = visible;
  }

  function clearLists() {
    if (productsList) productsList.innerHTML = '';
    if (collectionsList) collectionsList.innerHTML = '';
    if (productsSection) productsSection.hidden = true;
    if (collectionsSection) collectionsSection.hidden = true;
    if (emptyEl) emptyEl.hidden = true;
  }

  function escapeHtml(s) {
    return (s || '').replace(/[&<>"']/g, ch => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
    })[ch]);
  }

  function fmtMoney(price) {
    // Shopify suggest API returns price as string in dollars, e.g. "1200.00"
    if (price == null || price === '') return '';
    const n = parseFloat(price);
    if (isNaN(n)) return '';
    // UAH integer formatting: 1 200 ₴
    return Math.round(n).toLocaleString('uk-UA').replace(/,/g, ' ') + ' ₴';
  }

  function renderProduct(p) {
    const img = p.featured_image && p.featured_image.url
      ? `<img src="${escapeHtml(p.featured_image.url)}&width=120" alt="" loading="lazy" width="60" height="60">`
      : '<div class="durnev-search__results-noimg" aria-hidden="true"></div>';
    return `
      <li class="durnev-search__results-item">
        <a href="${escapeHtml(p.url)}">
          <div class="durnev-search__results-thumb">${img}</div>
          <div class="durnev-search__results-meta">
            <span class="durnev-search__results-name">${escapeHtml(p.title)}</span>
            <span class="durnev-search__results-price">${fmtMoney(p.price)}</span>
          </div>
        </a>
      </li>`;
  }

  function renderCollection(c) {
    return `
      <li class="durnev-search__results-item durnev-search__results-item--collection">
        <a href="${escapeHtml(c.url)}">
          <span class="durnev-search__results-name">${escapeHtml(c.title)}</span>
        </a>
      </li>`;
  }

  let lastReq = 0;
  function fetchSuggest(query) {
    const reqId = ++lastReq;
    const params = new URLSearchParams({
      q: query,
      'resources[type]': 'product,collection',
      'resources[limit]': '6',
      'resources[options][unavailable_products]': 'last',
    });
    return fetch(`/search/suggest.json?${params.toString()}`, {
      headers: { 'Accept': 'application/json' },
    })
      .then(r => r.json())
      .then(data => {
        if (reqId !== lastReq) return; // stale
        const r = data && data.resources && data.resources.results || {};
        const products = r.products || [];
        const collections = r.collections || [];

        clearLists();
        if (queryEcho) queryEcho.textContent = query;

        if (productsList && products.length) {
          productsList.innerHTML = products.map(renderProduct).join('');
          if (productsSection) productsSection.hidden = false;
        }
        if (collectionsList && collections.length) {
          collectionsList.innerHTML = collections.map(renderCollection).join('');
          if (collectionsSection) collectionsSection.hidden = false;
        }
        if (!products.length && !collections.length && emptyEl) {
          emptyEl.hidden = false;
        }
      })
      .catch(() => { /* swallow — keep auxiliary visible */ });
  }

  let timer = 0;
  input.addEventListener('input', function () {
    const q = input.value.trim();
    clearTimeout(timer);
    if (q.length < 2) {
      setVisibleAuxiliary(true);
      clearLists();
      return;
    }
    setVisibleAuxiliary(false);
    timer = setTimeout(() => fetchSuggest(q), 250);
  });

  // Reset when overlay closes / input cleared.
  input.addEventListener('search', function () {
    if (!input.value) {
      setVisibleAuxiliary(true);
      clearLists();
    }
  });

  // Suggestion chips ("КОТИК", "КОХАТЬ" etc.) — clicking a chip should
  // pre-fill the input and trigger the same predictive flow instead of
  // navigating away to /search?q=. We dispatch a synthetic `input` event
  // so the existing typing listener handles the rest.
  overlay.addEventListener('click', function (e) {
    const chip = e.target.closest('[data-search-chip]');
    if (!chip) return;
    e.preventDefault();
    const term = chip.getAttribute('data-search-chip') || '';
    input.value = term;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.focus();
  });
})();
